import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCalling = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 18" {...props}>
    <path
      d="M.643 14.678C.603 13.666.58 13.03.57 12.77c-.058-1.44.795-2.505 2.561-3.198 2.65-1.04 10.053-2.493 20.103.206 2.364.454 3.368 1.943 3.16 3.272-.138.886-.262 1.744-.372 2.573-.24 1.035-1.005 1.435-2.293 1.2-1.933-.352-1.288-.265-2.837-.582-1.549-.317-1.397-.448-2.1-2.175-.701-1.726-.278-2.158-2.645-2.254-1.578-.064-3.666-.082-6.265-.054-.918-.045-1.483.5-1.695 1.636-.317 1.703-.707 2.08-2.517 2.43a29.29 29.29 0 0 1-3.464.472C1.204 16.23.683 15.69.643 14.678zM27.452 6.63c1.667.239 2.57 1.185 2.707 2.839m-1.627-5.805c2.8.402 4.316 1.992 4.548 4.77M29.766.861c3.744.537 5.77 2.663 6.08 6.376"
      fill="none"
      stroke="#FFF"
    />
  </svg>
);
const Memo = memo(SvgCalling);
export default Memo;
